export default __webpack_public_path__ + "ad70c121bc136e8762b101b60be090a1.png";